/** Public page opened from the e-mail: the secret link activates the access once, then signs in. */

import { ApiError, useAuthInvitationAcceptCreate } from "@agencyos/api-client";
import { Backdrop, Button, GlassCard } from "@agencyos/ui-web";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import { session } from "../lib/session";

export function InvitationPage() {
  const { t } = useTranslation();
  const { token = "" } = useParams();
  const navigate = useNavigate();
  const accept = useAuthInvitationAcceptCreate();
  const failure = accept.error instanceof ApiError ? accept.error.detail : undefined;

  const onAccept = () =>
    accept.mutate(
      { data: { token } },
      {
        onSuccess: (response) => {
          if (response.status !== 200) return;
          session.signIn(response.data.access, response.data.organization_slug);
          navigate("/", { replace: true });
        },
      },
    );

  return (
    <main className="login">
      <Backdrop intensity="vivid" />
      <GlassCard level="thick" className="login-card stack">
        <h1>{t("team.welcomeTitle")}</h1>
        <p>{t("team.welcomeIntro")}</p>
        <Button disabled={accept.isPending || !token} onClick={onAccept}>
          {t("team.activate")}
        </Button>
        {accept.isError ? (
          <p role="alert" className="ko">
            {failure ?? t("common.error")}
          </p>
        ) : null}
      </GlassCard>
    </main>
  );
}
